import { useAppDispatch } from './reduxHooks'
import { pushWithRegion } from 'actions/NavigationActions'

export default function useNavigateTo() {
  const dispatch = useAppDispatch()
  return (path: string, search?: string) => dispatch(pushWithRegion(path, search))
}
